/**
 * Valida destino interno após login (evita open redirect).
 * Aceita path relativo com query, ex.: /curso-online/id/conteudo?trackId=1&stepId=x
 */
export function isSafeInternalRedirectPath(
  redirect: string | null | undefined
): redirect is string {
  if (redirect == null || typeof redirect !== 'string') return false
  const t = redirect.trim()
  if (t.length === 0 || t.length > 2048) return false
  if (!t.startsWith('/')) return false
  if (t.startsWith('//')) return false
  if (t.includes('://')) return false
  return true
}
